export default function isPromise(value: any) {
  return value && typeof value.then === 'function'
}
